import { useSessionUser } from '@/contexts/sessionUser';
import { User } from '@/types/auth';

export type UseAuthResult = {
  user: User | null;
  loading: boolean;
  error: Error | null;
};

/**
 * Returns the session user set by ProtectedRoute.
 * No extra API call — user is fetched once during session validation.
 */
export const useAuth = (): UseAuthResult => {
  const { user } = useSessionUser();
  return { user, loading: false, error: null };
};
